export default "__VITE_ASSET__BkLlq_zh__"